import { style } from "@react-spectrum/s2/style" with { type: "macro" };

const property = style({ color: "indigo-1000" });
const number = style({ color: "pink-1000" });
const fn = style({ color: "red-1000" });
const variable = style({ color: "fuchsia-1000" });
const comment = style({ color: "gray-700" });
const string = style({ color: "green-1000" });

const content = style({ fontFamily: "sans" });
const code = style({ fontFamily: "code" });
const title = style({ font: "heading" });
const bold = style({ fontWeight: "bold" });

/**
 * token
 * title
 * important
 * punctuation
 * bold
 * content
 * list
 */

export const prismStyles = {
  keyword: style({ color: "magenta-1000" }),
  string,
  number,
  boolean: number,
  property,
  attribute: property,
  function: fn,
  tag: fn,
  constructor: fn,
  comment,
  linenumber: style({ color: "gray-400" }),
  variable,
  hex: variable,
  regex: variable,
  deliminator: variable,
  url: style({ color: "blue-1000" }),
  import: style({ display: "--import-display" }),
  content,
  code,
  "code-language": string,
  title,
  bold,
  important: bold,
  punctuation: style({
    color: "neutral-subdued",
    fontFamily: "code",
    fontWeight: "detail",
  }),
  list: style({ display: "inherit", color: "yellow-1000" }),
  hr: bold,
  italic: style({ fontStyle: "italic" }),
  blockquote: style({
    display: "inline-block",
    paddingStart: 16,
    borderStyle: "solid",
    borderWidth: 0,
    borderStartWidth: 2,
    borderColor: "gray-400",
  }),
  strike: style({ textDecoration: "line-through" }),
};
